import constants from './BaseConstants';
export default {
  REG_SIGNUP_AS_MERCHANT: constants.BASE_URL + 'merchants/signup/signup_as_merchant',
  REG_VERIFY_EMAIL: constants.BASE_URL + 'signup/verify/',
  REG_VERIFY_EMAIL_TOKEN: constants.BASE_URL + '/merchants/signup/is_email_token_valid?token=',
  REG_UPDATE_PHONE: constants.BASE_URL + 'merchants/signup/update_phone',
  REG_VERIFY_PHONE_NUMBER: constants.BASE_URL + 'merchants/signup/verify_phone_number',
  REG_SEND_VERIFICATION: constants.BASE_URL + 'merchants/signup/send_verification',
  REG_CALL_TO_VERIFY: constants.BASE_URL + 'merchants/signup/call_with_verification',
  REG_CALL_TWILIO_CALLBACK: constants.BASE_URL + 'merchants/signup/twilio_callback',
  REG_OWNER_URL: constants.BASE_URL + 'merchants/signup/owner',
  REG_DATA: 'REG_DATA',
  REG_SET_ADDRESS: 'REG_SET_ADDRESS',
  REG_SET_FIELD: 'REG_SET_FIELD',
  REG_DATA_OWNER: 'REG_DATA_OWNER',
  REG_VERIFY_PHONE: 'REG_VERIFY_PHONE',
  REG_VERIFY_CODE: 'REG_VERIFY_CODE'
}



/** WEBPACK FOOTER **
 ** ./src/constants/RegistrationConstants.js
 **/